import dayjs from 'dayjs'
import statFilters from '@sportninja/common/constants/stat-filters'

const statFinder =
  (statName) =>
  ({ stats }) => {
    const s = stats.find(({ name }) => name.toLowerCase() === statName)
    return s ? s.value : 0
  }

const getStatColumns = (
  filterCollectionName,
  width = '5%',
  mobileWidth = '5%'
) =>
  statFilters[filterCollectionName].map((statName) => {
    return {
      Header: statFilters.abbreviations[statName],
      width,
      mobileWidth,
      accessor: statFinder(statName),
      sortDescFirst: true,
      fullName: statName,
      toolTip: statFilters.tooltips[statName],
    }
  })

const playerSort = ({ original: a }, { original: b }) => {
  const val1 = Object.prototype.hasOwnProperty.call(b, 'player')
    ? b.player.name_first.toLowerCase()
    : ''
  const val2 = Object.prototype.hasOwnProperty.call(a, 'player')
    ? a.player.name_first.toLowerCase()
    : ''

  if (val1 < val2) {
    return -1
  } else if (val1 === val2) {
    return 0
  } else {
    return 1
  }
}

const teamSort = ({ original: a }, { original: b }) => {
  const val1 = a.team.name_full.toLowerCase()
  const val2 = b.team.name_full.toLowerCase()

  if (val1 < val2) {
    return -1
  } else if (val1 === val2) {
    return 0
  } else {
    return 1
  }
}

const seasonSort = ({ original: a }, { original: b }) => {
  const val1 = dayjs(a.season.starts_at).unix()
  const val2 = dayjs(b.season.starts_at).unix()

  if (val1 < val2) {
    return -1
  } else if (val1 === val2) {
    return 0
  } else {
    return 1
  }
}

export default {
  getStatColumns,
  playerSort,
  seasonSort,
  teamSort,
}
